import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CustomToastMessageService } from 'src/app/user/shared/components/custom-toast-component/custom-toast-message/custom-toast-message.service';

@Component({
  selector: 'app-custom-toast-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-toast-message.component.html',
  styleUrl: './custom-toast-message.component.scss',
})
export class CustomToastMessageComponent implements OnInit, OnDestroy {
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'success';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() show: boolean = false;
  @Input() duration: number = 3000; // Default 3 seconds

  private timeoutId: any;
  private toastSubscription?: Subscription;

  constructor(
    private toastService: CustomToastMessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    console.log('CustomToastMessageComponent ngOnInit - subscribing to service');
    // Subscribe to toast service
    this.toastSubscription = this.toastService.toast$.subscribe(toast => {
      console.log('CustomToastMessageComponent received toast:', toast);
      if (toast) {
        this.showToast(toast.type, toast.title, toast.message, toast.duration);
        this.cdr.detectChanges();
      } else {
        this.close();
        this.cdr.detectChanges();
      }
    });

    if (this.show) {
      this.startAutoHide();
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
    }
  }

  close(): void {
    console.log('CustomToastMessageComponent close called');
    this.show = false;
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.cdr.detectChanges();
  }

  showToast(type: 'success' | 'error' | 'warning' | 'info', title: string, message: string, duration?: number): void {
    console.log('CustomToastMessageComponent showToast called:', { type, title, message, duration });
    this.type = type;
    this.title = title;
    this.message = message;
    this.show = true;
    if (duration) {
      this.duration = duration;
    } else {
      this.duration = 3000; // Ensure default duration
    }
    console.log('CustomToastMessageComponent show set to:', this.show);
    this.cdr.detectChanges();
    // Small delay to ensure DOM is updated before starting animation
    setTimeout(() => {
      this.startAutoHide();
    }, 10);
  }

  private startAutoHide(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.close();
    }, this.duration);
  }

  getIconClass(): string {
    return this.type === 'success' ? 'success-icon' : 'error-icon';
  }
}
